import React from 'react';

function isTooltipConfig(object) {
    if (!object) {
        return false;
    }
    return (typeof object.content) === 'string'
        || React.isValidElement(object.content
            || Array.isArray(object.content));
}
function getDUIPlacement(params) {
    if (params === 'right-prefer') {
        return ['right', 'left'];
    }
    if (params === 'left-prefer') {
        return ['left', 'right'];
    }
    return params;
}
function getDUIAlignment(params) {
    if (params === 'start-prefer') {
        return 'start';
    }
    if (params === 'end-prefer') {
        return 'end';
    }
    return params;
}

export { getDUIAlignment, getDUIPlacement, isTooltipConfig };
//# sourceMappingURL=tooltip-config.js.map
